import React from 'react';

const CastStrip = ({ cast }) => {
  if (!cast || cast.length === 0) return null;
  return (
    <section className="block" data-testid="show-cast">
      <h2 className="block-title">Top cast</h2>
      <div className="cast-grid">
        {cast.map((c) => (
          <div key={c.id} className="cast-card" data-testid={`cast-${c.id}`}>
            <div className="cast-photo">
              {c.profile_url ? (
                <img src={c.profile_url} alt={c.name} loading="lazy" />
              ) : (
                <div className="cast-fallback">{(c.name || '?').slice(0, 1)}</div>
              )}
            </div>
            <div className="cast-meta">
              <div className="cast-name">{c.name}</div>
              {c.character ? <div className="cast-character">as {c.character}</div> : null}
            </div>
          </div>
        ))}
      </div>

      <style jsx>{`
        .block {
          margin: 2.5rem 0;
        }
        .block-title {
          color: #E62F88;
          font-size: 0.72rem;
          font-weight: 800;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          margin: 0 0 1.1rem;
        }
        .cast-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
          gap: 0.85rem;
        }
        .cast-card {
          background: #131313;
          border: 1px solid #232323;
          border-radius: 10px;
          padding: 0.75rem;
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
          transition: border-color 0.18s, transform 0.18s;
        }
        .cast-card:hover {
          border-color: rgba(230, 47, 136, 0.4);
          transform: translateY(-2px);
        }
        .cast-photo {
          aspect-ratio: 1;
          border-radius: 999px;
          overflow: hidden;
          background: #0a0a0a;
          margin: 0 auto;
          width: 80px;
        }
        .cast-photo img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
        .cast-fallback {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #E62F88, #f5b942);
          color: #0a0a0a;
          font-weight: 800;
          font-size: 1.4rem;
        }
        .cast-meta {
          text-align: center;
        }
        .cast-name {
          color: #fff;
          font-weight: 700;
          font-size: 0.85rem;
          line-height: 1.25;
        }
        .cast-character {
          color: #a1a1aa;
          font-size: 0.75rem;
          margin-top: 0.2rem;
          line-height: 1.3;
        }
      `}</style>
    </section>
  );
};

export default CastStrip;
